export const WAREHOUSE_SERIES_CONTROL_SCREEN_KEY = 'warehouseSeriesControlV1';
